<template>
  <div class="box">
    <el-card class="query-card">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="200px" size="small"
        class="demo-ruleForm">
        <el-form-item :label="$t('findManagers.oldPassword')" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword" clearable class="narrow-input"
            :placeholder="$t('findManagers.pleaseEnterTheOriginalPassword')">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('findManagers.newPassword')" prop="newPassword">
          <el-input type="password" v-model="ruleForm.newPassword" show-password clearable class="narrow-input"
            :placeholder="$t('findManagers.passwordLimit')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('findManagers.confirmPassword')" prop="newPassword1">
          <el-input type="password" v-model="ruleForm.newPassword1" show-password clearable class="narrow-input"
            :placeholder="$t('findManagers.passwordLimit')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('submit') }}</el-button>
          <el-button @click="resetForm('ruleForm')">{{ $t('reset') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "showUpdatePassword",
  data() {
    // 密码正则：8~16位，字母、数字或下划线
    const passwordRegex = /^[a-zA-Z0-9_]{8,16}$/;

    const validateOldPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('findManagers.pleaseEnterTheOriginalPassword')));
      } else {
        callback();
      }
    };
    const validateNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('findManagers.pleaseEnterANewPassword')));
      } else if (!passwordRegex.test(value)) {
        callback(new Error(this.$t('findManagers.passwordLimit')));
      } else {
        // 新密码改变时，重新校验确认密码
        if (this.ruleForm.newPassword1 !== '') {
          this.$refs.ruleForm.validateField('newPassword1');
        }
        callback();
      }
    };
    const validateNewPassword1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('findManagers.pleaseReEnterTheNewPasswordToConfirm')));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error(this.$t('findManagers.passwordDifferent')));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        newPassword1: ''
      },
      rules: {
        oldPassword: [
          { required: true, validator: validateOldPassword, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validateNewPassword, trigger: 'blur' }
        ],
        newPassword1: [
          { required: true, validator: validateNewPassword1, trigger: 'blur' }
        ]
      },
    };


  },
  methods: {
    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            oldPwd: this.ruleForm.oldPassword || undefined,
            newPwd: this.ruleForm.newPassword || undefined,
          };
          this.$axios.put('/api/meradmin/pwd', params)
            .then(res => {
              if (res.data.code === 0) {
                this.$message.success(res.data.msg);
                this.resetForm(formName);
                this.logout();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(error => {
              this.$message.error(this.$t('requestFailed'));
              console.error(error);
            });
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },

    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 退出登录
    async logout() {
      try {
        await this.$axios.get('/api/meradmin/logout');
      } catch (error) {
        //console.error("登出请求失败", error);
      } finally {
        sessionStorage.clear();
        this.$router.push("/login");
      }
    }
  }
}
</script>

<style scoped>
.box {
  padding: 20px;
}

/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important;
  /* 强制加粗生效 */
  color: #303133 !important;
  /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 120px;
  text-align: right;
}


/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important;
  /* 强制生效 */
  color: #606266 !important;
  /* 强制生效 */
  border-radius: 6px !important;
  /* 强制微圆角生效 */
}

/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 输入框宽度 */
.narrow-input {
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/view/merchant/showUpdatePassword.vue